import request from '@oskecare/fe-utilities/lib/request';
import { bound } from '@oskecare/fe-utilities/lib/decorators';
import Offering from './Offering.js';
import Order from './Order.js';
import Inventory from './Inventory.js';
import TariffOption from './TariffOption.js';

export default class Products {
  /**
   * @param {Logger} logger
   * @param {CustomerDataManager} customerDataManager
   * @param {object} config
   */
  constructor({ logger, customerDataManager, config }) {
    this._logger = logger;
    this._cache = new Map();
    this.offering = new Offering({
      apiUrl: config.productOfferingApiUrl,
      cache: this._cache,
      request: this._request,
      customerDataManager,
    });
    this.order = new Order({
      apiUrl: config.productOrderV1ApiUrl,
      resetCache: this.resetCache,
      request: this._request,
      customerDataManager,
    });
    this.inventory = new Inventory({
      apiUrl: config.productApiUrl,
      cache: this._cache,
      request: this._request,
      customerDataManager,
    });
    this.tariffOption = new TariffOption({
      apiUrl: config.productDomainApiUrl,
      cache: this._cache,
      request: this._request,
      customerDataManager,
    });
  }

  /**
   * Proxy for `request` function with logSource pre-set
   *
   * @param {object} params
   * @return {Promise<*>}
   * @private
   */
  @bound
  _request(params) {
    return request({
      ...params,
      logSource: 'infra-product',
    }).catch(this._logger.catchError);
  }

  @bound
  resetCache() {
    this._cache.clear();
  }
}
